import {
  Box,
  Card,
  CardContent,
  Paper,
  Stack,
  Typography,
  Divider,
  CardMedia,
  Button,
 
} from "@mui/material";

import { Grid} from "@mui/material";
import { useState } from "react";
import { styled } from "@mui/material/styles";
import { theme } from "@/components/Elements/theme";
import cryptoPayments from "@/assets/cryptoPayments.svg";
import allPayments from "@/assets/allPayments.svg";
import { FiatPaymentModule } from "./fiatPaymentModule";
import { CryptoPaymentModule } from "./CryptoPaymentModule";
import React from "react";
import Swal from "sweetalert2";
import { getWalletAmount } from "@/components/Elements/api/getWalletamount";
import { useLocation } from "react-router-dom";

export const Payment = () => {
  const [cryptoPayment, setCryptoPayment] = useState(true);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const option = params.get("option");
  console.log("optionAbhay", option);
  const handleCryptoPayment = () => {
    setCryptoPayment(!cryptoPayment);
  };

  React.useEffect(() => {
    async function checkBalance() {
      let dataWallet = await getWalletAmount();
      console.log(dataWallet , "abhay")
      if (dataWallet?.walletAmount === 0) {
        Swal.fire({
          text: "Deposit : Top up your wallet with crypto currency or fiat money and start playing ",
          icon: "info",
          background: "black",
          color: "white",
          showCancelButton: false,
          confirmButtonText: "OK",
          allowOutsideClick: false,
        });
      }
    }
    if (option?.toLowerCase() === "fiat") {
      setCryptoPayment(false); // false = fiat selected
    } else {
      setCryptoPayment(true); // default to crypto
    }

    checkBalance();
  }, [option]);

  const Item = styled(Paper)(({ theme }) => ({
    background: "transparent",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  }));

  var cardStyle = {
    display: "block",
    transitionDuration: "0.3s",
    height: "492px",
    background: "#050518",
    boxShadow: "0px 4px 50px 30px rgba(181, 181, 181, 0.05)",
    borderRadius: "20px",
  };

  var center = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  var content = {
    color: "#ffff",
    backgroundColor: "#050518",
    borderRadius: "12px",
  };

  return (
    <Box sx={{ height: "auto", marginTop: "25px" }}>
      <Grid container spacing={{ xs: 1, md: 1.5, lg: 3 }}>
        <Grid item xs={6} md={6}>
          {" "}
          <Card
            style={cardStyle}
            sx={{
              p: { md: theme.spacing(0.3), xs: theme.spacing(0.1) },
              height: "100% !important",
              boxSizing: "border-box",
            }}
          >
            <CardContent
              sx={{ p: { md: theme.spacing(0.2), xs: theme.spacing(0.1) } }}
            >
              <Stack spacing={{ xs: "10px", md: "15px" }}>
                <Item>
                  {" "}
                  <Typography variant="h5">Deposit</Typography>
                </Item>
                <Item
                  sx={{
                    mt: {
                      xs: "0 !important",
                      md: "10px !important",
                      lg: "16px !important",
                    },
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{ color: "#7E7E7E", textTransform: "uppercase" }}
                  >
                    Select Payment System
                  </Typography>
                </Item>
                <Divider
                  sx={{ border: "1px solid rgba(255, 255, 255, 0.2)" }}
                />
                <Item>
                  <Grid item xs={12} sm={12} md={12} flexGrow={1}>
                    <Card
                      style={content}
                      onClick={handleCryptoPayment}
                      sx={{
                        background: "rgba(255, 255, 255, 0.03) !important",
                        display: "flex",
                      }}
                      className={cryptoPayment ? "activePayment" : ""}
                      //onClick={}
                    >
                      <CardMedia
                        component="img"
                        sx={{
                          borderRadius: "10px",
                          p: { md: theme.spacing(0.3), xs: theme.spacing(0.2) },
                          width: { md: "150.06px", xs: "80px" },
                          height: { md: "129.68px", xs: "80px" },
                        }}
                        image={cryptoPayments}
                        alt="Live from space album cover"
                      />
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          flex: "1 1 auto",
                        }}
                      >
                        <CardContent
                          sx={{
                            flex: "1 0 auto",
                            p: "0 !important",
                            my: { xs: "10px", md: "15px" },
                          }}
                        >
                          <Stack
                            spacing={{ xs: "10px", md: "15px" }}
                            flex="1 0 1"
                          >
                            <Box>
                              <Typography component="h6" variant="h6">
                                Crypto Payment
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                mt: {
                                  xs: "5px !important",
                                  md: "15px !important",
                                },
                              }}
                            >
                              <Typography
                                component="h3"
                                variant="h3"
                                sx={{
                                  color: "#A3A9AD",
                                  fontSize: { xs: "10px", md: "14px" },
                                }}
                              >
                                Minimum - 5(USD) | Maximum - 10.000(USD)
                              </Typography>
                            </Box>

                            <Box
                              sx={{
                                mt: {
                                  xs: "10px !important",
                                  md: "15px !important",
                                },
                              }}
                            >
                              <Button
                                sx={{
                                  padding: {
                                    xs: "6px 10px",
                                    lg: "7.73px 19px",
                                  },
                                  fontSize: { xs: "12px", md: "14px" },
                                  backgroundColor: "rgba(60, 55, 255, 0.15)",
                                  color: "#3C37FF",
                                  borderRadius: "19px",
                                }}
                              >
                                No Payment fees
                              </Button>
                            </Box>
                          </Stack>
                        </CardContent>
                      </Box>
                    </Card>
                  </Grid>
                </Item>
                <Item>
                  <Grid item xs={12} sm={12} md={12}>
                    <Card
                      style={content}
                      onClick={handleCryptoPayment}
                      sx={{
                        background: "rgba(255, 255, 255, 0.03) !important",
                        display: "flex",
                      }}
                      className={!cryptoPayment ? "activePayment" : ""}
                    >
                      <CardMedia
                        component="img"
                        sx={{
                          borderRadius: "10px",
                          p: { md: theme.spacing(0.3), xs: theme.spacing(0.2) },
                          width: { md: "150.06px", xs: "80px" },
                          height: { md: "129.68px", xs: "80px" },
                        }}
                        image={allPayments}
                        alt="Live from space album cover"
                      />
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          flex: "1 1 auto",
                        }}
                      >
                        <CardContent
                          sx={{
                            flex: "1 0 auto",
                            p: "0 !important",
                            my: { xs: "10px", md: "15px" },
                          }}
                        >
                          <Stack spacing={2} flex="1 0 1">
                            <Box>
                              <Typography component="h6" variant="h6">
                                Fiat Payments
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                mt: {
                                  xs: "5px !important",
                                  md: "15px !important",
                                },
                              }}
                            >
                              <Typography
                                component="h3"
                                variant="h3"
                                sx={{
                                  color: "#A3A9AD",
                                  fontSize: { xs: "10px", md: "14px" },
                                }}
                              >
                                Minimum - 5(USD) | Maximum - 10.000(USD)
                              </Typography>
                            </Box>

                            <Box
                              sx={{
                                mt: {
                                  xs: "10px !important",
                                  md: "15px !important",
                                },
                              }}
                            >
                              <Button
                                sx={{
                                  padding: {
                                    xs: "6px 10px",
                                    lg: "7.73px 19px",
                                  },
                                  fontSize: { xs: "12px", md: "14px" },
                                  backgroundColor: "rgba(60, 55, 255, 0.15)",
                                  color: "#3C37FF",
                                  borderRadius: "19px",
                                }}
                              >
                                No Payment fees
                              </Button>
                            </Box>
                          </Stack>
                        </CardContent>
                      </Box>
                    </Card>
                  </Grid>
                </Item>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        {cryptoPayment ? <CryptoPaymentModule /> : (
          <Grid item xs={6} md={6}>
            <Card
              style={cardStyle}
              sx={{
                p: { md: theme.spacing(0.3), xs: theme.spacing(0.1) },
                height: "100% !important",
                boxSizing: "border-box",
              }}
            >
              <CardContent
                sx={{ 
                  p: { md: theme.spacing(0.2), xs: theme.spacing(0.1) },
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  height: '100%'
                }}
              >
                {/* Golden Ticket Section */}
                <Box sx={{ width: '100%', mb: 2 }}>
                  <Box 
                    sx={{ 
                      background: "#191932",
                      borderRadius: "12px", 
                      p: { md: 2, xs: 1.5 }, 
                      mb: 2,
                      border: "1px solid rgba(25, 25, 50, 0.1)",
                      position: 'relative',
                      overflow: 'hidden',
                      opacity: 0.05,
                      // '&:hover': {
                      //   opacity: 0.8,
                      //   border: "1px solid rgba(255, 215, 0, 0.3)",
                      //   transition: 'all 1s ease-in-out',
                      //   background: "linear-gradient(135deg, #191932 0%, #2a2a4a 100%)"
                      // }
                    }}
                  >
                    <Typography 
                      variant="caption" 
                      sx={{ 
                        color: "rgba(255, 215, 0, 0.7)", 
                        textAlign: 'center',
                        fontWeight: 'bold',
                        mb: 1,
                        fontSize: { xs: '12px', md: '14px' },
                        display: 'block'
                      }}
                    >
                      🎯 Hunter Reward!
                    </Typography>
                    <Typography 
                      variant="caption" 
                      sx={{ 
                        color: "rgba(255, 255, 255, 0.8)", 
                        textAlign: 'center',
                        mb: 1.5,
                        fontSize: { xs: '9px', md: '11px' },
                        display: 'block'
                      }}
                    >
                      You've made it all the way into the wallet & payments section – that's real hunter behavior.
                    </Typography>
                    <Box 
                      sx={{ 
                        backgroundColor: "rgba(0,0,0,0.4)", 
                        borderRadius: "8px", 
                        p: 1.5,
                        border: "1px solid rgba(255, 215, 0, 0.4)"
                      }}
                    >
                      <Typography 
                        variant="caption" 
                        sx={{ 
                          color: "rgba(255, 215, 0, 0.9)", 
                          textAlign: 'center',
                          fontWeight: 'bold',
                          mb: 0.5,
                          fontSize: { xs: '9px', md: '11px' },
                          display: 'block'
                        }}
                      >
                        Golden Ticket Code
                      </Typography>
                      <Typography 
                        variant="h6" 
                        sx={{ 
                          color: "rgba(255, 255, 255, 0.9)", 
                          textAlign: 'center',
                          fontFamily: 'monospace',
                          letterSpacing: 1,
                          fontSize: { xs: '11px', md: '14px' },
                          fontWeight: 'bold'
                        }}
                      >
                        3AFPONAYT8ZL
                      </Typography>
                    </Box>
                    <Typography 
                      variant="caption" 
                      sx={{ 
                        color: "rgba(163, 169, 173, 0.7)", 
                        textAlign: 'center',
                        mt: 1,
                        display: 'block',
                        fontSize: { xs: '7px', md: '9px' },
                        lineHeight: 1.2
                      }}
                    >
                      Log in to redeem, then share your screenshot on X with @Gateway2Fortune #MervsDiamondHunt
                    </Typography>
                  </Box>
                  
                  {/* Diamond Ticket Boost Notice */}
                  <Typography 
                    variant="caption" 
                    sx={{ 
                      color: "rgba(60, 55, 255, 0.1)", 
                      textAlign: 'center',
                      fontSize: { xs: '6px', md: '8px' },
                      fontStyle: 'italic',
                      opacity: 0.05,
                      '&:hover': {
                        opacity: 0.6,
                        color: "rgba(60, 55, 255, 0.8)",
                        transition: 'all 0.8s ease'
                      }
                    }}
                  >
                    💎 Every Finale ticket you buy also helps boost the Diamond Ticket prize.
                  </Typography>
                </Box>

                {/* Original Fiat Payment Content */}
                <Box sx={{ textAlign: 'center' }}>
                  <Typography 
                    variant="h4" 
                    sx={{ 
                      color: "#7E7E7E", 
                      textAlign: 'center',
                      mb: 2
                    }}
                  >
                    Fiat Payment
                  </Typography>
                  <Typography 
                    variant="h5" 
                    sx={{ 
                      color: "#3C37FF", 
                      textAlign: 'center',
                      fontWeight: 'bold'
                    }}
                  >
                    Coming Soon
                  </Typography>
                  <Typography 
                    variant="body1" 
                    sx={{ 
                      color: "#A3A9AD", 
                      textAlign: 'center',
                      mt: 2
                    }}
                  >
                    We're working on bringing you fiat payment options. Stay tuned!
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
